export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_neuss-auto-repair/artifacts/tazoxwvl_image.png";

// Optional: nur das Auto-Symbol als kleinere quadratische Variante (wird per CSS aus dem
// vollen Logo zugeschnitten — siehe Verwendung in Navbar/Footer/AdminLogin)
export const LOGO_ICON_URL = LOGO_URL;
